import React, { Suspense } from 'react'
import { ModalContextProvider, Snackbar } from '@ggs/ui/common'
import { MuiThemeProvider } from '@ggs/styles'
import { StoreProvider, GlobalActionsDispatcher } from '@ggs/store'
import { I18nextProvider } from 'react-i18next'
import { i18n } from '@ggs/i18n'

/**
 * @typedef {Object} RootProvidersProps
 * @property {Element|JSX.Element} children
 */

/**
 * Composition of providers dependencies.
 * @param {RootProvidersProps} props
 * @return {JSX.Element}
 */
export default function RootProviders({ children }) {
  return (
    <I18nextProvider i18n={i18n}>
      <StoreProvider>
        <GlobalActionsDispatcher>
          <MuiThemeProvider>
            <ModalContextProvider>
              <Suspense fallback="loading">{children}</Suspense>
              <Snackbar />
            </ModalContextProvider>
          </MuiThemeProvider>
        </GlobalActionsDispatcher>
      </StoreProvider>
    </I18nextProvider>
  )
}
